export const FILE_SIZE = 5 * 1024 * 1024
export const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png']
